import classNames from "classnames";

export interface HelpTextProps {
  id: string;
  helpText: React.ReactNode;
  className?: React.HTMLAttributes<HTMLElement>["className"];
}

export const HelpText = (props: HelpTextProps) => {
  return (
    <small
      id={props.id}
      className={classNames("form-text text-muted mt-n1 mb-1", props.className)}
    >
      {props.helpText}
    </small>
  );
};
